const MAX_ENTRIES = 16;

class DataLru {
  constructor(max = MAX_ENTRIES) {
    this.max = max;
    this.map = new Map();
  }

  get(key) {
    if (!this.map.has(key)) return undefined;
    const value = this.map.get(key);
    this.map.delete(key);
    this.map.set(key, value);
    return value;
  }

  set(key, value) {
    if (this.map.has(key)) this.map.delete(key);
    this.map.set(key, value);
    while (this.map.size > this.max) {
      const oldest = this.map.keys().next().value;
      this.map.delete(oldest);
    }
    return this;
  }

  has(key) {
    return this.map.has(key);
  }

  delete(key) {
    return this.map.delete(key);
  }

  keys() {
    return this.map.keys();
  }

  ownKeys() {
    return [...this.map.keys()];
  }
}

const lru = new DataLru();

const dataCache = new Proxy(lru, {
  get(target, prop) {
    if (prop === 'then' || typeof prop === 'symbol') return undefined;
    if (prop in target && typeof target[prop] === 'function') {
      return target[prop].bind(target);
    }
    return target.get(prop);
  },
  set(target, prop, value) {
    target.set(String(prop), value);
    return true;
  },
  deleteProperty(target, prop) {
    target.delete(String(prop));
    return true;
  },
  has(target, prop) {
    return target.has(String(prop));
  },
  ownKeys(target) {
    return target.ownKeys();
  },
  getOwnPropertyDescriptor(target, prop) {
    if (!target.has(String(prop))) return undefined;
    return { configurable: true, enumerable: true, writable: true, value: target.get(String(prop)) };
  },
});

export default dataCache;
